import { navigate } from 'gatsby';
import React, { FC } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';

import { exists } from '@utils/general';

import theme from '@theme/FolxTheme';

interface IDashedLinkButtonProps {
	label: string;
	href: string;
	prefix?: string;
	variant?: 'small' | 'default';
}

const DashedButton = styled.button<{ variant: 'small' | 'default' }>`
	align-items: center;
	background: ${theme.colors.lightGray};
	border: 0.1rem dashed ${theme.colors.black};
	border-radius: ${theme.radius.md};
	cursor: pointer;
	display: flex;
	height: ${({ variant }) => variant === 'default' && theme.spacing.xxxxl};
	justify-content: center;
	padding: ${({ variant }) => variant === 'small' && theme.spacing.lg};
	width: 100%;
`;

const DashedLinkButton: FC<IDashedLinkButtonProps> = ({
	label,
	href,
	prefix = '+',
	variant = 'default',
}) => {
	return (
		<DashedButton onClick={() => navigate(href)} variant={variant}>
			{exists(prefix) && <BasicText>{prefix}&nbsp;</BasicText>}
			<BasicText underline>{label}</BasicText>
		</DashedButton>
	);
};

export default styled(DashedLinkButton)``;
